// extracted by mini-css-extract-plugin
var _1 = "AuthHelpText-moduleAuthHelpText__HX0rS";
export { _1 as "AuthHelpText" }
